import { ColocaSurface } from "@/shared/components/layout/ColocaSurface";
import useTranslations from "@/shared/lang/useTranslations";

import type { OtcOrder } from "../../types/cryptoSwaps.types";
import { OrderDetailsList } from "./OrderDetailsList";

export interface OrderSummaryCardProps {
  order: OtcOrder;
}

export function OrderSummaryCard({ order }: OrderSummaryCardProps) {
  const { t } = useTranslations("cryptoSwaps");

  return (
    <ColocaSurface className="flex flex-col gap-4 rounded-2xl">
      <h2 className="text-xs font-semibold tracking-[0.08em] text-muted-foreground uppercase">
        {t("summary_title")}
      </h2>
      <OrderDetailsList order={order} />
    </ColocaSurface>
  );
}
